import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import ModalImage from "react-modal-image";
import { formatDate, formatMoney } from "utils";

function Txn(props) {
  const { data } = props;
  let attachment = data?.get("attachment");
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);


  const normalView = () => {
    return (
      <div className="d-flex pe-0 p-md-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 pe-0 text-end" style={{ minWidth: "min-content" }}>
          <i className="fs-xmd-smaller text-nowrap">
            {formatMoney(Math.abs(data.get("amount")))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              <small className="text-break text-wrap">{data.get("detail")}</small>
              <div align="right">
                <small align="right"><i className="text-nowrap">{formatDate(data.get("date"))}</i></small>
              </div>
            </div>
            <div align="left">
              {isImage &&
                <div className="container p-0 " >
                  <ModalImage
                    small={data.get("attachment")}
                    large={data.get("attachment")}
                    hideDownload={true}
                    hideZoom={true}
                    className="uploadbillpreview"
                  />
                </div>
              }
              {isPDF && (<a role="button"
                href={attachment}
                target="_blank"
                className="cursor-pointer">
                <i className="bi bi-file-pdf-fill text-app fs-1"
                  size={50} />
              </a>)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <li className="list-group-item bg-transparent ">
      <div className="row">
        {!data.get("cancelled") && normalView()}
      </div>
    </li>
  )
}

export default Txn;
